const htmlw = window.innerWidth
document.querySelector('html').style.fontSize = htmlw/10+'px'

window.onload = () => {
  if (document.querySelector('#app')) {
    document.querySelector('#app').style.opacity= 1;
  }
}

